@if (medicalRecordEntries.length > 0) {
  <div class="cards-container">
    <div class="card">
      <div class="title-card-container">
        <h3 class="card-title">{{ 'medicalHistory.attending_physician' | translate }}</h3>
      </div>

      <div class="text-container" nz-row>
        <div nz-col nzXs="24" nzSm="24" nzMd="8" nzLg="8" nzXl="8">
          <p class="subtitle">{{ 'medicalHistory.name' | translate }}</p>
          <p class="data">{{ doctorDetails?.name }} {{ doctorDetails?.surname }}</p>
        </div>
        <div class="details-container" nz-col nzXs="24" nzSm="24" nzMd="8" nzLg="8" nzXl="8">
          <button class="details-button" (click)="openDetails()">
            {{ 'medicalHistory.details' | translate }}
          </button>
        </div>
      </div>
      <div class="text-container" nz-row>
        <div nz-col nzXs="24" nzSm="24" nzMd="8" nzLg="8" nzXl="8">
          <p class="subtitle">{{ 'medicalHistory.telephone' | translate }}</p>
          <p class="data">{{ doctorDetails?.phone }}</p>
        </div>
        <div nz-col nzXs="24" nzSm="24" nzMd="8" nzLg="8" nzXl="8">
          <p class="subtitle">{{ 'medicalHistory.email' | translate }}</p>
          <p class="data">{{ doctorDetails?.mail }}</p>
        </div>
      </div>
    </div>
    @for (record of medicalRecordEntries; track record.key) {
      <div class="card">
        <div class="title-card-container">
          <h3 class="card-title">{{ 'medicalHistory.' + record.key + '.plural' | translate | titlecase }}</h3>
          <ds-button
            [text]="isDesktop ? ('medicalHistory.add_new_register' | translate) : null"
            [iconLeft]="'/public/assets/images/PlusCircleBlue.svg'"
            [styleType]="'undressed-main'"
            [width]="'small'"
            (click)="openModal(record.key)"
          ></ds-button>
        </div>
        @if (record.isEmpty) {
          <div class="text-container" nz-row>
            <p>{{ 'medicalHistory.no_registered' | translate }} {{ 'medicalHistory.' + record.key + '.singular' | translate }}</p>
          </div>
        } @else {
          @for (item of record.items; track item) {
            <div class="text-container" [ngClass]="{ bordered: record.items.length > 1 && !item.isLast }" nz-row nzGutter="16">
              <div nz-col nzXs="12" nzSm="12" nzMd="5" nzLg="5" nzXl="5">
                <p class="subtitle">{{ 'medicalHistory.date' | translate }}</p>
                <p class="data">{{ item.date | date: 'dd/MM/yyyy' }}</p>
              </div>
              <div nz-col nzXs="12" nzSm="12" nzMd="6" nzLg="6" nzXl="6">
                <p class="subtitle">{{ 'medicalHistory.typology' | translate }}</p>
                <p class="data">{{ item.type }}</p>
              </div>
              <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12">
                <p class="subtitle">{{ 'medicalHistory.additional_notes' | translate }}</p>
                <p class="data">{{ item.notes || 'Nessuna nota disponibile' }}</p>
              </div>
              <span nz-icon nzType="more" nzTheme="outline" nz-popover nzPopoverTrigger="click" [nzPopoverContent]="recordActions"></span>
              <ng-template #recordActions>
                <button class="btn-edit" nz-button nzType="link" (click)="editRecord(record, item)">
                  {{ 'buttons.edit' | translate | titlecase }}
                </button>
                <button class="btn-delete" nz-button nzType="link" (click)="delete(record, item)">
                  {{ 'buttons.delete' | translate | titlecase }}
                </button>
              </ng-template>
            </div>
          }
          <nz-divider> </nz-divider>
          <span class="show-all" (click)="showAll(record.key)">{{'show_all' | translate}}</span>
        }
      </div>
    }
  </div>
}
